import { h, ComponentChildren } from 'preact'
import { PureComponent, createContext } from 'preact-compat'
import Icon from '../../assets'
import idGenerator from '../../utils/idGenerator'

let defaultIds: undefined|string
export const LabelId = createContext(defaultIds)
export const ValidationErrorId = createContext(defaultIds)

interface LabelProps {
  children: ComponentChildren
  isControl?: boolean
}

export class Label extends PureComponent<LabelProps> {
  render ({ children, isControl }: LabelProps) {
    return (
      <LabelId.Consumer>
        {(id) => {
          return (
            <label for={id} className={`a-label a-label--app-${isControl ? 'control' : 'destination'}`}>
              {children}
            </label>
          )
        }}
      </LabelId.Consumer>
    )
  }
}

interface ValidationErrorProps {
  children: ComponentChildren
  isControl?: boolean
}

export class ValidationError extends PureComponent<ValidationErrorProps> {
  render ({ children, isControl }: ValidationErrorProps) {
    return (
      <ValidationErrorId.Consumer>
        {(id) => {
          return (
            <div className={`a-validation-error a-validation-error--app-${isControl ? 'control' : 'destination'}`}>
              <Icon customClass='a-validation-error__icon' icon='warning' />
              <span id={id} className='a-validation-error__message'>{children}</span>
            </div>
          )
        }}
      </ValidationErrorId.Consumer>
    )
  }
}

interface InputUnitProps {
  children: ComponentChildren
  error?: string
  isControl?: boolean
  label?: string
}

class InputUnit extends PureComponent<InputUnitProps> {
  render ({ children, error, isControl, label }: InputUnitProps) {
    return (
      <LabelId.Provider value={label ? idGenerator(label) : undefined}>
        <ValidationErrorId.Provider value={error ? idGenerator('validation-error') : undefined}>
          <div className='m-input-unit'>
            {label && <Label isControl={isControl}>{label}</Label>}
            {children}
            {error && <ValidationError isControl={isControl}>{error}</ValidationError>}
          </div>
        </ValidationErrorId.Provider>
      </LabelId.Provider>
    )
  }
}

export default InputUnit
